import {
    GET_BOT_DATA,
    TOGGLE_SIDE_BAR,
    TOGGLE_BOT_CUSTOM_STATE,
    CURRENT_TAB_STATUS,
    UPDATE_BOT_DATA,
    UPSERT_BOT_DATA,
    UPDATE_SELECTED_BOT_ID,
    UPDATE_BLOCKED_UI_STATE,
    DOWNLOAD_BOT_CONFIG,
    UPDATE_SELECTED_BOT,
    UPDATE_USER_DETAILS,
    GET_BOT_LIST_DATA,
    UPDATE_BOT_LIST,
    GET_SELECTED_BOT_DATA,
    UPDATE_SELECTED_BOT_CONFIG,
    BUILD_BOT,
    REMOVE_SELECTED_BOT,
    USER_LOGOUT,
    GET_LOGS,
    GET_LOGS_SUCCESS,
    GET_LOGS_ERROR,
    LOAD_CONFIG,
    LOAD_CONFIG_SUCCESS,
    LOAD_CONFIG_ERROR,
    HIGHLIGHT_SEARCHED_RESULT,
    UPDATE_GENERIC_TAB_STATUS,
    GET_GENERIC_DATA,
    SUCCESS_GENERIC_DATA,
    SAVE_GENRIC_DATA,
    SUCCESS_SAVE_GENRIC_DATA,
    DOWNLOAD_GENERIC_DATA,
    RELOGIN_USER,
    RESET_VERSION,
    UPDATE_CURRENT_FIRSTPARAM,
    UPDATE_GENERIC_LANG,
    UPDATE_CREATE_MENU_VISIBILITY,
    UPDATE_CREATE_MENU_DATA,
    UPDATE_CREATE_MENU_TYPE,
    GET_BOT_INFO,
    GET_BOT_INFO_SUCCESS,
    GET_BOT_INFO_ERROR,
    UPDATE_SELECTED_SOURCE,
    GET_SOURCE_LIST,
    GET_SOURCE_LIST_SUCCESS,
    GET_SOURCE_LIST_ERROR
} from './actions';

import { store } from '../../../index';

let blockUiTimeOut;
let count = 0;


export const currentUserLogout = () => ({
    type: USER_LOGOUT
});

export const getBotConfigData = (botId,baseUrl) => ({
    type:GET_BOT_DATA,
    botId,
    baseUrl
});

export const updateBotValue = (updatedBotData, times, version) => ({
    type: UPDATE_BOT_DATA,
    value: updatedBotData,
    times,
    version
})

export const toggleSideBar = (sidebar_state) => ({
    type: TOGGLE_SIDE_BAR,
    value: sidebar_state
});

export const makeBotCustom = (custom_state) => ({
    type: TOGGLE_BOT_CUSTOM_STATE,
    value: custom_state
});

export const updateCurrentTabStatus = (currentTab) => ({
    type: CURRENT_TAB_STATUS,
    value: currentTab
});

export const upsertBotConfigData = (updatedBotData, version, cb, err) => {
    return ({
        type: UPSERT_BOT_DATA,
        botData: updatedBotData,
        version: version,
        cb,
        err
    });
}

export const resetVersion = () => ({
    type: RESET_VERSION
})

export const blockUiFun = (blocked_ui_state, buildState) => {
    // console.log('before blocked_ui_state -> ', blocked_ui_state, count)
    if(blocked_ui_state) {
        count ++;
    } else {
        count --;
    }
    // console.log('after blocked_ui_state -> ', blocked_ui_state, count)
    clearTimeout(blockUiTimeOut);
    if(!blocked_ui_state) {
        // clearTimeout(blockUiTimeOut);
    } else if(buildState) {

    } else {
        blockUiTimeOut = setTimeout(() => {
            store.dispatch({
                type: UPDATE_BLOCKED_UI_STATE,
                value: false
            });
            blockUiFun(false);
            return;
        },15000);
    }
    return {
        type: UPDATE_BLOCKED_UI_STATE,
        value: blocked_ui_state
    };
}

export const downloadBotConfigData = (cb, err) => ({
    type: DOWNLOAD_BOT_CONFIG,
    cb,
    err
})

export const getSelectedBotData = (selectedBotID, cb, errFn, skipConfigUpsert) => ({
        type: GET_SELECTED_BOT_DATA,
        botId: selectedBotID,
        cb,
        errFn,
        skipConfigUpsert: skipConfigUpsert || false
})

export const updateSelectedBot = (value) => ({
    type: UPDATE_SELECTED_BOT,
    value: value === false ? value : true
})

export const removeSelectedBot = () => ({
    type: REMOVE_SELECTED_BOT
})

export const updateUserData = (data) => ({
    type: UPDATE_USER_DETAILS,
    value: data.user
})

export const updateSelectedBotId = (id, name) => ({
    type: UPDATE_SELECTED_BOT_ID,
    value: {id, name}
})

export const getBotListData = (cb, err) => ({
    type: GET_BOT_LIST_DATA,
    cb,
    err
})

export const updateBotListData = (data) => ({
    type: UPDATE_BOT_LIST,
    value: data
})

export const updateBotValueConfig = (data, botId) => ({
    type: UPDATE_SELECTED_BOT_CONFIG,
    value: data['bot-config'],
    kbId: data['kbId'],
    botId
})

export const builBotByData = (env, baseUrl, sources, cb, err) => ({
    type: BUILD_BOT,
    env,
    baseUrl,
    sources,
    cb,
    err
})

export const getLogs = (filter, cb, fromDash, botId) => ({
    type: GET_LOGS,
    filter,
    botId,
    cb,
    fromDash
})

export const getLogsSuccess = (response) => ({
    type: GET_LOGS_SUCCESS,
    response
})

export const getLogsError = () => ({
    type: GET_LOGS_ERROR
})

export const loadConfig = (id, cb) => ({
    type: LOAD_CONFIG,
    id,
    cb
})

export const loadConfigSuccess = (response) => ({
    type: LOAD_CONFIG_SUCCESS,
    response
})

export const loadConfigError = () => ({
    type: LOAD_CONFIG_ERROR
})

export const highlightSearchedResult = (searchedData) => ({
    type: HIGHLIGHT_SEARCHED_RESULT,
    data: searchedData
})


export const updateCurrentGenericTabStatus = (currentTab) => ({
    type: UPDATE_GENERIC_TAB_STATUS,
    currentTab
})

export const getGenericData = (lang, cb, err) => ({
    type: GET_GENERIC_DATA,
    lang,
    cb,
    err
})

export const downloadGenericData = (lang, cb, err) => ({
    type: DOWNLOAD_GENERIC_DATA,
    lang,
    cb,
    err
})

export const successGenericDataGet = (data) => ({
    type: SUCCESS_GENERIC_DATA,
    data
})

export const saveGenericData = (lang, data, cb, err) => ({
    type: SAVE_GENRIC_DATA,
    lang,
    cb,
    err,
    data
})

export const successSaveGenericData = (data) => ({
    type: SUCCESS_SAVE_GENRIC_DATA,
    data
})

export const reloginUser = () => ({
    type: RELOGIN_USER
})

export const updateFirstParam = (value) => ({
    type: UPDATE_CURRENT_FIRSTPARAM,
    value
})

export const updateGenericLang = (value) => ({
    type: UPDATE_GENERIC_LANG,
    value
})

export const updateCreateMenuVisiblity = (value) => ({
    type: UPDATE_CREATE_MENU_VISIBILITY,
    value
})

export const updateCreateMenuData = (value) => ({
    type: UPDATE_CREATE_MENU_DATA,
    value
})

export const updateCreateMenuType = (value) => ({
    type: UPDATE_CREATE_MENU_TYPE,
    value
})



export const getBotInfo = (botId) => ({
    type: GET_BOT_INFO,
    botId
})

export const getBotInfoSuccess = (response) => ({
    type: GET_BOT_INFO_SUCCESS,
    value: response
})

export const getBotInfoError = () => ({
    type: GET_BOT_INFO_ERROR
})

export const updateSelectedSource = (data) => ({
    type: UPDATE_SELECTED_SOURCE,
    data
})

export const getSourceList = (botId, cb, errCb) => ({
    type: GET_SOURCE_LIST,
    botId,
    cb,
    errCb
})

export const getSourceListSuccess = (response) => ({
    type: GET_SOURCE_LIST_SUCCESS,
    value: response
})

export const getSourceListError = () => ({
    type: GET_SOURCE_LIST_ERROR,
})
